import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

let id = 0;
@Component({
  selector: 'ps-ui-capsule-radio-button',
  templateUrl: './capsule-radio-button.component.html',
  styleUrls: ['./capsule-radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CapsuleRadioButtonComponent,
      multi: true,
    },
  ],
})
export class CapsuleRadioButtonComponent implements ControlValueAccessor {
  @Input() value: boolean = false;
  @Input() onLabel: string = 'On';
  @Input() offLabel: string = 'Off';
  @Input() id: string = `ToggleSwitch-${id++}`;
  @Output() valueChange = new EventEmitter<boolean>();

  onChange?: (arg: boolean) => void;

  updateValue(value: boolean): void {
    this.value = value;
    if (this.onChange) {
      this.onChange(value);
    }
    this.valueChange.emit(value);
  }

  writeValue(value: boolean): void {
    this.value = value;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(): void {
    // do nothing. Needed for ControlValueAccessor interface
  }
}
